module.exports = __webpack_public_path__ + "img/lx-code.96da3e77.jpg";